import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../client';
import { processDraftKeys, processKeys } from '../../query-keys';
import { setDraftResurveyAllContract, type SetDraftResurveyAllResponse } from '@bliks-io/contracts';

/**
 * Flag (or clear) the survey re-request on every survey-eligible draft step at
 * once. Applied on publish (ADR 0009). Invalidates the draft query so the
 * per-step toggles reflect the new state.
 */
export function useSetDraftResurveyAll(processId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ value }: { value: boolean }): Promise<SetDraftResurveyAllResponse> => {
      const path = setDraftResurveyAllContract.path.replace(':processId', processId);
      const { data } = await apiClient.patch<SetDraftResurveyAllResponse>(path, {
        value
      });
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: processDraftKeys.detail(processId)
      });
      void queryClient.invalidateQueries({ queryKey: processKeys.list(), refetchType: 'none' });
    }
  });
}
